import { useInView } from 'react-intersection-observer'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import 'react-lazy-load-image-component/src/effects/blur.css'

import style from './style.scss'

type Props = {
  alt: string
  src: string
  onLoaded?: () => void
  sizes: string
  srcSet: string
}

const observerOptions = {
  threshold: 0,
  rootMargin: '500px 0px 500px 0px',
  triggerOnce: true,
}

function LoadableImage({ alt, onLoaded, sizes, src, srcSet }: Props) {
  const [ref, inView] = useInView(observerOptions)

  const placeholderSrc = srcSet.split(',')[0].split(' ')[0]

  return (
    <div ref={ref}>
      {inView && (
        <LazyLoadImage
          afterLoad={onLoaded}
          alt={alt}
          delayTime={800}
          effect='blur'
          placeholderSrc={placeholderSrc}
          scrollPosition={undefined}
          sizes={sizes}
          src={src}
          srcSet={srcSet}
          wrapperClassName={style.wrapper}
        />
      )}
    </div>
  )
}

export default LoadableImage
